import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Grid,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Box,
  Avatar,
  Paper,
  IconButton,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteIcon from "@mui/icons-material/Delete";
import { add_CustomNotification } from "../../Services/api";

const NotificationCreate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    message: "",
    image: null,
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.match("image.*")) {
        toast.error("Please select an image file");
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        toast.error("File size should be less than 5MB");
        return;
      }

      setFormData((prev) => ({ ...prev, image: file }));
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleRemoveImage = () => {
    setPreviewUrl(null);
    setFormData((prev) => ({ ...prev, image: null }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!formData.title || !formData.message) {
        toast.error("Title and Message are required");
        return;
      }

      // API call would go here

      const formDataObj = new FormData();
      formDataObj.append("type", "Image");
      formDataObj.append("storage", "server");
      formDataObj.append(`image`, formData.image);
      formDataObj.append("title", formData.title);
      formDataObj.append("message", formData.message);
      try {
        setLoading(true);
        const res = await add_CustomNotification(formDataObj);
        setTimeout(() => {
          navigate("/notifications");
        }, 2000);
      } catch (error) {
        console.error("Image upload error:", error);
        toast.error("Failed to upload image", { position: "top-center" });
      } finally {
        setLoading(false);
      }

      toast.success("Notification created successfully!");
    } catch (error) {
      toast.error("Failed to create notification");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <ToastContainer position="top-right" autoClose={5000} />

      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
          Add Custom Notification
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="title"
                label="Title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                name="message"
                label="message"
                value={formData.message}
                onChange={handleChange}
                multiline
                rows={4}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{
                  border: "1px dashed grey",
                  p: 2,
                  borderRadius: 1,
                  textAlign: "center",
                  backgroundColor: previewUrl ? "transparent" : "#f5f5f5",
                  position: "relative",
                }}
              >
                {previewUrl ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Box sx={{ position: "relative" }}>
                      <Avatar
                        src={previewUrl}
                        alt="Preview"
                        sx={{ width: 200, height: 200, mb: 2 }}
                        variant="rounded"
                      />
                      <IconButton
                        aria-label="remove image"
                        onClick={handleRemoveImage}
                        sx={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          backgroundColor: "rgba(255,255,255,0.7)",
                          "&:hover": {
                            backgroundColor: "rgba(255,255,255,0.9)",
                          },
                        }}
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                    </Box>
                    <Button
                      variant="outlined"
                      component="label"
                      color="secondary"
                    >
                      Change Image
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                    </Button>
                  </Box>
                ) : (
                  <Box>
                    <Button variant="outlined" component="label">
                      Upload Image (Optional)
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                    </Button>
                    <Typography
                      variant="caption"
                      display="block"
                      sx={{ mt: 1 }}
                    >
                      Maximum file size: 5MB
                    </Typography>
                  </Box>
                )}
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 2,
              }}
            >
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={loading}
                startIcon={
                  loading && <CircularProgress size={20} color="inherit" />
                }
              >
                Save Notification
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};

export default NotificationCreate;
